// extracted by mini-css-extract-plugin
module.exports = {"paymentStatus":"payment-card-status_paymentStatus__2jADu","paymentStatusLabel":"payment-card-status_paymentStatusLabel__3C3ri"};